import { useMutation } from '@tanstack/react-query'

import { updateCardAccountUnit } from '@src/api'
import { useAxios } from '@src/hooks'

import { MutationCardAccountArgs } from './type'

export const useUpdateCardAccountUnit = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: ({ params, organizationId }: MutationCardAccountArgs) =>
      updateCardAccountUnit(axiosInstance, organizationId, params),
  })
}
